import '../../../../../styles.scss';
import React, { useState } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { ASSET_PATH } from '../../../../consts/env.consts';
import DogNamesPage from '../../../../pages/dog-names';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const client = new ApolloClient({
    uri: '/graphql',
    cache: new InMemoryCache(),
});

const DogNames =
    ({ dataSSR, categoriesSSR }, { pathname }) =>
    () => {
        return (
            <ApolloProvider client={client}>
                <DogNamesPage {...{ dataSSR, categoriesSSR, pathname, useStateSSR: useState }} />
            </ApolloProvider>
        );
    };

export default DogNames;
